module.exports = __webpack_public_path__ + "img/arrow-repeat.560b4f36.svg";